import { render, staticRenderFns } from "./Bereikt.vue?vue&type=template&id=04a99d16&scoped=true&"
import script from "./Bereikt.vue?vue&type=script&lang=js&"
export * from "./Bereikt.vue?vue&type=script&lang=js&"
import style0 from "./Bereikt.vue?vue&type=style&index=0&id=04a99d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a99d16",
  null
  
)

export default component.exports